/**
 * @generated SignedSource<<901bb2a807991af4a9d54cf18c167bdb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateTimeRegInput = {
  taskId?: string | null;
  idleTimeId?: string | null;
  projectId?: string | null;
  year?: number | null;
  month?: number | null;
  day?: number | null;
  minutesRegistered?: number | null;
  billableMinutesRegistered?: number | null;
  harvestTaskId?: string | null;
  unit4ActivityId?: string | null;
  unit4ActivityName?: string | null;
  personId?: string | null;
  roleId?: string | null;
  billable?: boolean | null;
  notes?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createTimeRegMutation$variables = {
  input: CreateTimeRegInput;
};
export type createTimeRegMutation$data = {
  readonly createTimeReg: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly task: {
      readonly id: string;
      readonly totalMinutesRegistered: number | null;
    } | null;
    readonly timeReg: {
      readonly node: {
        readonly id: string;
      } | null;
    } | null;
  } | null;
};
export type createTimeRegMutation = {
  variables: createTimeRegMutation$variables;
  response: createTimeRegMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTimeRegPayload",
    "kind": "LinkedField",
    "name": "createTimeReg",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalMinutesRegistered",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TimeRegTypeEdge",
        "kind": "LinkedField",
        "name": "timeReg",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TimeRegType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createTimeRegMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createTimeRegMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "b9c7f6b43307f61bb19dafdb18cc4ed5",
    "id": null,
    "metadata": {},
    "name": "createTimeRegMutation",
    "operationKind": "mutation",
    "text": "mutation createTimeRegMutation(\n  $input: CreateTimeRegInput!\n) {\n  createTimeReg(input: $input) {\n    errors\n    task {\n      id\n      totalMinutesRegistered\n    }\n    timeReg {\n      node {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f35effff7ba3c4c9ed9eb8e453993a1a";

export default node;
